<template>
  <div class="table-resonsive">
    <Hypertable
      request="/account/loadTeamFull"
      :fields="fields"
      :show_footer="true"
      :simulate_pagination="true"
      :show_fast_date_selector="true"
      :show_total="true"
      :total_label="$t('message.account.team_analytics_total')"
    />
  </div>
</template>
<script>
import Hypertable from "../hypertable.vue";
export default {
  components: { Hypertable },
  data() {
    return {
      fields: [
        // {
        //     key: 'company',
        //     label: this.$t('message.contracts.company_name'),
        //     sortable: true,
        //     formatter: (value, key, item) => {
        //         return item.company_name+' ('+item.company_code+')'
        //     },
        //     summable: false
        // },
        {
          key: "name",
          label: this.$t("message.account.org_founders_person_name"),
          sortable: true,
          formatter: (value, key, item) => {
            if (item.first_name == "") return "";
            if (item.first_name) return item.first_name + " " + item.last_name;
          },
          summable: false,
        },
        {
          key: "position",
          label: this.$t("message.account.position"),
          sortable: true,
          summable: false,
        },
        {
          key: "is_active",
          label: this.$t("message.account.team_status"),
          sortable: true,
          summable: false,
          formatter: (value, key, item) => {
            if (item.is_active == "") return "";
            if (item.is_active == 1)
              return this.$t("message.account.team_status_active");
            return this.$t("message.account.team_status_inactive");
          },
        },
        {
          key: "ca_clicks",
          label: this.$t("message.account.analytics_ca_clicks"),
          sortable: true,
          summable: true,
        },
        {
          key: "ca_cost",
          label: this.$t("message.account.analytics_ca_cost"),
          sortable: true,
          summable: true,
          formatter: (value, key, item) => {
            return window.rubFormat(value);
          },
        },
        {
          key: "ca410_clicks",
          label: this.$t("message.account.analytics_search_clicks410"),
          sortable: true,
          summable: true,
        },
        {
          key: "ca410_cost",
          label: this.$t("message.account.analytics_search_cost410"),
          sortable: true,
          summable: true,
          formatter: (value, key, item) => {
            return window.rubFormat(value);
          },
        },
        {
          key: "search_clicks",
          label: this.$t("message.account.analytics_search_clicks"),
          sortable: true,
          summable: true,
        },
        {
          key: "search_cost",
          label: this.$t("message.account.analytics_search_cost"),
          sortable: true,
          summable: true,
          formatter: (value, key, item) => {
            return window.rubFormat(value);
          },
        },
        {
          key: "note_clicks",
          label: this.$t("message.account.analytics_note_clicks"),
          sortable: true,
          summable: true,
        },
        {
          key: "note_cost",
          label: this.$t("message.account.analytics_note_cost"),
          sortable: true,
          summable: true,
          formatter: (value, key, item) => {
            return window.rubFormat(value);
          },
        },
      ],
    };
  },
};
</script>
